import { render, staticRenderFns } from "./_documents.vue?vue&type=template&id=b2ec35e6&"
import script from "./_documents.vue?vue&type=script&lang=js&"
export * from "./_documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports